import { useQuery } from '@apollo/client'
import * as Sentry from '@sentry/browser'
import React, { useMemo } from 'react'
import { User, UserContext } from './UserContext'
import GraphqlError from '../components/GraphqlError'
import Loading from '../components/Loading'
import { viewerQuery } from '../generated/graphql'
import Viewers from '../schema/Viewers'

export const UserProvider: React.FC = ({ children }) => {
  const { loading, error, data, refetch } = useQuery<viewerQuery>(Viewers.GET_VIEWER)
  const user = useMemo(() => {
    if (data && data.viewer) {
      Sentry.configureScope(function (scope) {
        scope.setUser({
          username: data.viewer.username,
          id: data.viewer.id,
        })
        scope.setTag('locale', data.viewer.locale)
        scope.setTag('role', data.viewer.role)
      })
    }
    return new User(data?.viewer, refetch)
  }, [data, refetch])
  if (loading) {
    return <Loading />
  } else if (error) {
    return <GraphqlError error={error} />
  }
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}
